"use client";

import React, {Suspense} from "react";
import {usePathname} from "next/navigation";
import {GoogleAnalytics, GoogleTagManager} from "@next/third-parties/google";
import {ClientAnalyticsProvider} from "@/components/providers/client/AnalyticsProvider";

export function isAssetSpecificPath(pathname: string | null): boolean {
    const segments = (pathname ?? "").split("/").filter(Boolean);

    return (
        (segments[0] === "asset" && Boolean(segments[1]))
        || (segments[1] === "asset" && Boolean(segments[2]))
    );
}

export function TrackingProviders(
    { dictionary, children }: { dictionary: any, children: React.ReactNode }
) {

    return (
        <>
            {children}
            <Suspense fallback={null}>
                <TrackingWidgets dictionary={dictionary}/>
            </Suspense>
        </>
    );
}

function TrackingWidgets({dictionary}: {dictionary: any}) {
    const pathname = usePathname();

    if (!pathname || isAssetSpecificPath(pathname)) {
        return null;
    }

    return (
        <>
            <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID!} />
            <GoogleTagManager gtmId="GTM-NVRRMZSM" />
            <ClientAnalyticsProvider dictionary={dictionary}>
                {null}
            </ClientAnalyticsProvider>
        </>
    );

}
